/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_MInputs */

const en_val_m = /** @type {(inputs: Val_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

const es_val_m = /** @type {(inputs: Val_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

const fr_val_m = /** @type {(inputs: Val_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

const de_val_m = /** @type {(inputs: Val_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

const ja_val_m = /** @type {(inputs: Val_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

const zh_val_m = /** @type {(inputs: Val_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

const ar_val_m = /** @type {(inputs: Val_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متوسط (M)`)
};

const id_val_m = /** @type {(inputs: Val_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

const it_val_m = /** @type {(inputs: Val_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

const ru_val_m = /** @type {(inputs: Val_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

const pt_val_m = /** @type {(inputs: Val_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

const ko_val_m = /** @type {(inputs: Val_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

/**
* | output |
* | --- |
* | "M" |
*
* @param {Val_MInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_m = /** @type {((inputs?: Val_MInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_MInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_m(inputs)
	if (locale === "es") return es_val_m(inputs)
	if (locale === "fr") return fr_val_m(inputs)
	if (locale === "de") return de_val_m(inputs)
	if (locale === "ja") return ja_val_m(inputs)
	if (locale === "zh") return zh_val_m(inputs)
	if (locale === "ar") return ar_val_m(inputs)
	if (locale === "id") return id_val_m(inputs)
	if (locale === "it") return it_val_m(inputs)
	if (locale === "ru") return ru_val_m(inputs)
	if (locale === "pt") return pt_val_m(inputs)
	return ko_val_m(inputs)
});